import { useContext } from "react";
import { ConfigurationEventEmitterContext, } from "../context/ConfigurationEventEmitterContext";
import { useConfigurationApi } from "../hooks/useConfigurationApi";
import { configureCustomStore } from "./configureCustomStore";
const thunkExtraArgument = (() => {
    let _cfgApi;
    let _emitter;
    return {
        get cfgApi() {
            return _cfgApi;
        },
        set cfgApi(api) {
            _cfgApi = api;
        },
        get eventEmitter() {
            return _emitter;
        },
        set eventEmitter(emitter) {
            _emitter = emitter;
        },
    };
})();
// creates store only once
const getStore = (() => {
    let store;
    return () => {
        if (!store) {
            store = configureCustomStore(thunkExtraArgument);
        }
        return store;
    };
})();
/**
 * Uses a single global store
 *
 * The single global store prevents issues with the redux dev tools instance list being flooded with new instances.
 * Without the the hacks below, the store needs to be re-created when the `thunkExtraArgument` changes.
 */
export function useGlobalStore() {
    const cfgApi = useConfigurationApi();
    const eventEmitter = useContext(ConfigurationEventEmitterContext);
    thunkExtraArgument.cfgApi = cfgApi; // very hacky
    thunkExtraArgument.eventEmitter = eventEmitter; // even more hacky
    return getStore();
}
//# sourceMappingURL=useGlobalStore.js.map